import React from 'react';
import { Outlet } from 'react-router-dom';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';
export function PublicLayout({
  context
}: {
  context?: Record<string, unknown>;
}) {
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-889" data-mp="4nk7rdjz8zbo">
      <PublicHeader data-id="element-890" data-mp="3vu4uil301l2w" />
      <main className="flex-1" data-id="element-891" data-mp="3vumyk3vwl3ld">
        <Outlet context={context} data-id="element-892" data-mp="3vvfv6c15ecps" />
      </main>
      <PublicFooter data-id="element-893" data-mp="xbzap1pu3r6n" />
    </div>;
}